import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { CiscoUiModule } from '../cisco-ui/cisco-ui.module';

import { MatSnackBarModule } from '@angular/material';


import { NotificationsService } from './notifications.service';

@NgModule({
  imports: [
    CommonModule,
    CiscoUiModule,

    MatSnackBarModule,
  ],
  providers: [NotificationsService]
})
export class NotificationsModule { }
